import { AxiosResponse,AxiosError } from "axios";
import React, { useEffect, useState } from "react";
import {
  Activity,
  ActivityActivity,
} from "../../interface/Activity";
import { Option } from "../../interface/Option";
import { ActivityAxiosInstance } from "../../Network/ActivityAxiosInstance";
import ListOfCustomActivities from "../Shared/ListOfActivities";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ActivitySelector from "../Shared/ActivityType"; 
import ListOfCustomActivityGroups from "../Shared/ListOfCustomActivityGroups";
import { ColumnDef } from "@tanstack/react-table";
import { DataTable } from "shared/DataTable";
import { Button } from "../../components/ui/button";
const ActivityGrouping: React.FC = () => {
  const [items, setItems] = useState<Activity>({ activities: [] });
   const [name, setName] = useState<string>("");
  const [ActivityType, setActivityType] = useState<string>("");
  const [selectedCustomActivityGroups, setSelectedCustomActivityGroups] = useState<Option[]>([]);
  const [MedicalActivityGroup, setMedicalActivityGroup] = useState<string[]>([]);
  const [selectedActivities, setSelectedActivities] = useState<Option[]>([]);
  const [activityTypeisValid, setActivityTypeIsValid] = useState<boolean>(true); 
  const [activityTypeError, setActivityTypeError] = useState<string>("");
  const [isMixedGroup, setisMixedGroup] = useState<boolean>(true);
  const [groupType, setGroupType] = useState<number | null>(null);
  const token = localStorage.getItem('token') || "";
  const [editIndex, setEditIndex] = useState<null | number>(null);
  const [NameError, setNameError] = useState<string>("");
  const [NameisValid, setNameIsValid] = useState<boolean>(true);
  const [selectedActivitiesisValid, setSelectedActivitiesIsValid] = useState<boolean>(true); 
  const [selectedActivitiesError, setSelectedActivitiesError] = useState<string>("");
  const [reloadTrigger, setReloadTrigger] = useState(false);
  const [clearListOfActivities, setClearListOfActivities] = useState(false);
  const [clearSelectedCustomActivityGroups, setClearSelectedCustomActivityGroups] = useState(false);
  useEffect(() => {
    fetchItems();
  }, []);
  useEffect(() => {
    if (clearListOfActivities||clearSelectedCustomActivityGroups) {
      setClearListOfActivities(false); 
      setClearSelectedCustomActivityGroups(false); 

      // clear select option for ListOfActivities and SelectedCustomActivityGroups
    }
  }, [clearListOfActivities,clearSelectedCustomActivityGroups]);
  const clear= ()=>{
    setName("");
        setSelectedActivities([]);
       
        setSelectedCustomActivityGroups([]);
        setMedicalActivityGroup([]);
  setActivityType('')
        setisMixedGroup(true);
        setGroupType(null);
 }
  const handleNameBlur = (): void => {
    if (!name.trim()) {
      setNameError("Group Name is required");
      setNameIsValid(false); 
  
    } else {
      setNameError("");
      setNameIsValid(true);
    }
  };
  const Namevalidate = (): boolean => {
    if (!name.trim()) {
      setNameError("Name is required");
      setNameIsValid(false); 

      return false;
    }
    setNameError("");
    setNameIsValid(true);

    return true;
  };
  const validateName = (name: string) => {
    if (name.trim()) {
      setNameError("");
    setNameIsValid(true);    
    } else {
      setNameError("Name is required");
      setNameIsValid(false);    
    }
  };
  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setName(value);
  // Check as you type
  validateName(value);  
  };
  const handleActivityTypeBlur = (): void => {
    if (!ActivityType.trim()) {
      setActivityTypeError("Type is required");
      setActivityTypeIsValid(false); 
  
    } else {
      setActivityTypeError("");
      setActivityTypeIsValid(true);
    }
  };
    const ActivityTypevalidate = (): boolean => {
      if (!ActivityType.trim()) {
        setActivityTypeError("Type is required");
        setActivityTypeIsValid(false); 
  
        return false;
      }
      setActivityTypeError("");
      setActivityTypeIsValid(true);
  
      return true;
    };
    const handleSelectedActivitiesBlur = (): void => {
      if (!selectedActivities) {
        setSelectedActivitiesError("Code are required");
        setActivityTypeIsValid(false);
      } else {
        setSelectedActivitiesError("");
        setActivityTypeIsValid(true);
      }
    };
    const handleActivityTypeChange = (ActivityType: string) => {
      setActivityType(ActivityType); //Update the status of the selected activityType
    };
  const handleActivitiesChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setSelectedActivities(selectedOptions);
  };
  const handleCustomActivityGroupsChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setSelectedCustomActivityGroups(selectedOptions);
  };
  const handleAddOrDeleteGroup = () => {
    setReloadTrigger(!reloadTrigger); 
     };

  //............................................. get data ...............................................

  const fetchItems = async (): Promise<void> => {
    try {
      const response: AxiosResponse<{
        success: boolean;
        activities: ActivityActivity[];
      }> = await ActivityAxiosInstance.put("getActivity");
      if (response.data.success && Array.isArray(response.data.activities)) {
        setItems({ activities: response.data.activities });
        console.log(response.data.activities);
      } else {
        throw new Error("Invalid response format");
      }
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };
  //............................................. end get data ...............................................
  //............................................. add data ...............................................

  const addItem = async (): Promise<void> => {
    const activities = selectedActivities.map(option => option.value);
    const CustomActivitysGroups = selectedCustomActivityGroups.map(option => option.value);

    const isFormValid = Namevalidate();
    const isFormValid2 = ActivityTypevalidate();

    if (!isFormValid || !isFormValid2) {
      return;
    }
    try {
  
      const newActivity = {
        name: name,
        activity: activities,
        activity_Type:ActivityType,
        custom_activity_group: CustomActivitysGroups,
        medical_activity_group: MedicalActivityGroup,
        is_mixed_group: isMixedGroup,
        type: groupType,
        token: token,
      };
      const response=await ActivityAxiosInstance.post("addActivity", newActivity);
      if (response.data.success) {
        fetchItems();
     clear();
     handleAddOrDeleteGroup();
     setNameIsValid(true); 
        setActivityTypeIsValid(true); 
        toast.success("New Group added successfully.");
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        console.error("Error adding item:", error);
        setNameIsValid(false); 
        setActivityTypeIsValid(false); 

        toast.error(`${error.response.data.error}`);
      } else {
    // If there is another error unrelated to the response such as a connection interruption
      toast.error('An unexpected error occurred.');
      }
    }
     
  };

  //.............................................end add data ...............................................
  //............................................. remove data ...............................................

  const removeItem = async (id: string | number): Promise<void> => {
  
    try {
      await ActivityAxiosInstance.delete(`deleteActivity/${id}`, {
       
         data: { token: token }, 
       });
      console.log(id);
      fetchItems();
      handleAddOrDeleteGroup();

    } catch (error) {
      console.error("Error removing item:", error);
    }
  };
  //.............................................end remove data ...............................................
  // ..................................................update data...............................
  const updateItem = async (id: string | number): Promise<void> => {
    const activities = selectedActivities.map(option => option.value);
    const CustomActivitysGroups = selectedCustomActivityGroups.map(option => option.value);
    const isFormValid = Namevalidate();
    const isFormValid2 = ActivityTypevalidate();

    if (!isFormValid || !isFormValid2) {
      return;
    }
    try {
const updatedItem = {
        name: name,
        activity: activities,
        activity_Type:ActivityType,
        custom_activity_group: CustomActivitysGroups,
        medical_activity_group: MedicalActivityGroup,
        is_mixed_group: isMixedGroup,
        type: groupType,
        token: token,
        id: id,
       
      };

      const response = await ActivityAxiosInstance.put(`updateActivity`, updatedItem);
      if (response.data.success) {
        fetchItems(); 
        clear(); 
        handleAddOrDeleteGroup();
        setNameIsValid(true); 
        setSelectedActivitiesIsValid(true); 
        toast.success("New Group update successfully.");
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        console.error("Error adding item:", error);
    
        toast.error(`${error.response.data.error}`);
      } else {
  // If there is another error unrelated to the response such as a connection interruption
        toast.error('An unexpected error occurred.');
      }
    }
  };

  //.............................................end update data ...............................................
  const handleEdit =  (item: ActivityActivity) => {
    let activities: Option[] = [];

    if (Array.isArray(item.activity)) {
      activities = item.activity.map((activity: string) => ({
        label: activity,
        value: activity,
      }));
    } else if (typeof item.activity === 'string') {
      activities = [{
        label: item.activity,
        value: item.activity,
      }];
    }
  
    setSelectedActivities(activities); 
    setActivityType(item.activity_type);
     setName(item.name)
    setMedicalActivityGroup(item.medical_activity_group);
    const CustomActivityGroups = (item.custom_activity_group || []).map((custom_activity_group: number) => ({
      label: String(custom_activity_group),
      value: custom_activity_group,          
    }));

    setSelectedCustomActivityGroups(CustomActivityGroups);
    setisMixedGroup(item.is_mixed_group);

setGroupType(item.type);
    setEditIndex(item.id);
  }
  
  const columns: ColumnDef<ActivityActivity>[] = [
    {
      accessorKey: "id",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          ID
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },
    {
      accessorKey: "name",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
 Name
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },
    {
      accessorKey: "activity",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
Activity
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const activities = row.getValue("activity") as string[];
        return Array.isArray(activities) ? activities.join(", ") : activities;
      },
    },
    {
      accessorKey: "activity_type",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
        ActivityType
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },
    {
      accessorKey: "medical_activity_group",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >MedicalActivityGroup
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const medical = row.getValue("medical_activity_group") as string[];
        return Array.isArray(medical) ? medical.join(", ") : medical;
      },
    }, {
      accessorKey: "custom_activity_group",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
CustomActivityGroup
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const custom = row.getValue("custom_activity_group") as string[];
        return Array.isArray(custom) ? custom.join(", ") : custom;
      },
    }, {
      accessorKey: "is_mixed_group",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
IsMixedGroup          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    }, {
      accessorKey: "type",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
 Type
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },  
  ];

  return (
    <div className=" container" style={{ margin: "30px" }}>
      {/* title */}
      <h5>
        Activity Grouping Screen{" "}
        <span>
          {" "}
          <i className="fa-solid fa-briefcase"></i>{" "}
        </span>{" "}
      </h5>
  



      {/* model */}
      {/* tabIndex="-1" */}
      <div
        className="modal fade"
        id="exampleModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Add Item
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={(e) => { 
                  setEditIndex(null);
                   clear(); 
                   setNameIsValid(true)
                   setSelectedActivitiesIsValid(true)
                   setNameError("")
                   setSelectedActivitiesError("")
                   handleAddOrDeleteGroup();
                   setisMixedGroup(true)
                   setActivityTypeIsValid(true); 
                   setActivityTypeError("");
                 }}
              >
                {" "}
              </button>
            </div>

            <div className=" container d-flex flex-column align-items-center ">
            <div style={{ margin: "15px"  ,width:"80%"} }>   
            <div style={{ marginTop: "10px",width:"400PX"}}>

               <label className="m-2">Activity Name</label>

             <input
    type="text"
    className="form-control"
    style={{ marginBottom: "7px"         ,  
      borderColor: !NameisValid ?  "red": "", 
      transition: "border-color 0.3s",
    }}
    value={name}
      // Check as you type
 onChange={handleNameChange}
    // Check when exiting input

    onBlur={handleNameBlur} 
  />
                   { NameError&& <div style={{ color: "red" }}>{NameError}</div>}

  {/* Show the error message only if name is empty */}
  </div>

                   
  <div style={{ marginTop: "10px",width:"500PX"}}>
              <label className="form-label">Type:</label>
              <div    onBlur={handleActivityTypeBlur} >            
              <ActivitySelector 
  onSelectActivity={handleActivityTypeChange}
  selectedActivityType={ActivityType} 

/>
</div>
{ activityTypeError&& <div style={{ color: "red" }}>{activityTypeError}</div>}
</div>


<div style={{ marginTop: "10px",width:"500PX"}}>
<label className="m-2">list of Activity Groups :</label>
<div    onBlur={handleSelectedActivitiesBlur}  >            

<ListOfCustomActivities
  isValid={ activityTypeisValid}
  onChange={handleActivitiesChange}
  selectedActivityType={ActivityType}
  defaultValue={selectedActivities}
  clear={clearListOfActivities}
  
/>
 </div>
 </div>
 

                <div style={{ marginTop: "10px",width:"400PX"}}>

<label className="m-2">Medical Activity Group</label>

<input
type="text"
className="form-control"
style={{ marginBottom: "7px"  }}
value={MedicalActivityGroup}
onChange={(e) =>
  setMedicalActivityGroup(e.target.value.split(","))
}
 
/></div>
             
<div style={{ marginTop: "10px",width:"500PX"}}>
<label className="m-2">Custom Activity Groups:</label>
<div >            

<ListOfCustomActivityGroups onChange={handleCustomActivityGroupsChange}   defaultValue={selectedCustomActivityGroups}
  clear={clearSelectedCustomActivityGroups }reloadTrigger={reloadTrigger} />
</div> </div>
            
<span>
  <label className="">Is Mixed Group :</label>
  <span style={{ marginRight: "10px" }}>
    {" "}
    True:{" "}
    <input
      type="radio"
      name="boolean"
      value={isMixedGroup.toString()}
      onChange={(e) => setisMixedGroup(true)}

    />{" "}
  </span>
  <span>
    {" "}
    False:{" "}
    <input
      type="radio"
      name="boolean"
      value={isMixedGroup.toString()}
      onChange={(e) => setisMixedGroup(false)}
    />{" "}
  </span>
</span>
                  
              {!isMixedGroup && (
                <div>
                  <label className="m-2 ">Group Type :</label>
                  <input
                    type="text"
                    className="form-control"
                    style={{ marginBottom: "10px" }}
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    value={groupType !== null ? groupType.toString() : ""}
                    onChange={(e) => {
                      const inputValue = e.target.value.trim();

                      setGroupType(
                        inputValue !== "" ? parseInt(inputValue) : null
                      );
                    }}
                  />
                </div>
              )}
            </div>
            </div>

            <div className="modal-footer">
            <button
                type="button"
                className="btn btn-primary"
                onClick={
                  editIndex === null ? addItem : () => updateItem(editIndex)
                }
                disabled={!selectedActivitiesisValid || !activityTypeisValid ||!NameisValid}

              >
                {editIndex === null ? "Add Item" : "Update Item"}
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={(e) => { 
                  setEditIndex(null);
                   clear(); 
                   setNameIsValid(true)
                   setSelectedActivitiesIsValid(true)
                   setNameError("")
                   setSelectedActivitiesError("")
                   handleAddOrDeleteGroup();
                   setisMixedGroup(true)
                   setActivityTypeIsValid(true); 
                   setActivityTypeError("");
                 }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* table */}
 

<DataTable
  columns={columns}
  data={items.activities}
  searchColumn="name"
  addButtonLabel="Add New Custom Activity" // Custom button text
  modalId="exampleModal" // Custom add modal ID
  showAddButton={true} // Control visibility
  onEdit={handleEdit}
  onDelete={removeItem}
/>
      {/*show message */}
      <ToastContainer
   
   position="top-center"
   autoClose={5000}
   hideProgressBar={false}
   newestOnTop={false}
   closeOnClick
   rtl={false}
   pauseOnFocusLoss
   draggable
   pauseOnHover
 />
    </div>
  );
};
export default ActivityGrouping;
